export default {
  init() {
    // JavaScript to be fired on the about us page
  },
  finalize() {
      $('.owl-carousel-heritage').owlCarousel({
      
      loop: false,
      autoplay: false,      
      dots: false,      
      items: 1,
      URLhashListener:true,      
      smartSpeed: 1000,
      lazyLoadEager: 3,
      startPosition: 'URLHash',
      responsive : {
        // breakpoint from 0 up
        0 : {
            
        },
        // breakpoint from 480 up
        480 : {
            
        },
        // breakpoint from 768 up
        768 : {
           
        },
      }, 



     });

  },
};


// WEBPACK FOOTER //
// ./scripts/routes/heritage.js